import { useMutation, UseMutationResult } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

/**
 * Hook para obtener la plantilla de YPF como una mutation.
 *
 * @returns La mutation para obtener la plantilla de YPF.
 */
export const useGetYpfTemplate = (): UseMutationResult<Blob, Error, void> => {
    return useMutation<Blob, Error, void>({
        mutationFn: async () => {
            const chatService = new ChatService();
            const response = await chatService.getYpfTemplate();
            return response;
        },
    });
};
